import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useMemo, useCallback } from 'react';
import Pagination from '../services/Pagination';
type Range = {
  start: number;
  end: number;
};
function getRange(itemsByPage: number, page: number): Range {
  const start = itemsByPage * (page - 1);
  const end = start + itemsByPage - 1;
  return {
    start,
    end
  };
}
type UsePaginationParams = {
  callback?: (start: number, end: number) => void;
  itemsByPage: number;
  defaultPage?: number;
};
type UsePaginationReturn = [Pagination, Range, (total?: number) => number];
export default function usePagination(t0) {
  const $ = _c(15);
  const {
    callback,
    itemsByPage,
    defaultPage: t1
  } = t0;
  const defaultPage = t1 === undefined ? 1 : t1;
  const [currentPage, setPage] = useState(defaultPage);
  let t2;
  if ($[0] !== currentPage || $[1] !== itemsByPage) {
    t2 = getRange(itemsByPage, currentPage);
    $[0] = currentPage;
    $[1] = itemsByPage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const range = t2;
  let t3;
  if ($[3] !== defaultPage) {
    t3 = new Pagination(setPage, defaultPage);
    $[3] = defaultPage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const pagination = t3;
  let t4;
  if ($[5] !== itemsByPage) {
    t4 = t5 => {
      const total = t5 === undefined ? 0 : t5;
      return Math.ceil(total / itemsByPage);
    };
    $[5] = itemsByPage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const getTotalPages = t4;
  let t5;
  let t6;
  if ($[7] !== callback || $[8] !== range) {
    t5 = () => {
      if (!callback) {
        return;
      }
      const {
        start,
        end
      } = range;
      callback(start, end);
    };
    t6 = [callback, range];
    $[7] = callback;
    $[8] = range;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== getTotalPages || $[12] !== pagination || $[13] !== range) {
    t7 = [pagination, range, getTotalPages];
    $[11] = getTotalPages;
    $[12] = pagination;
    $[13] = range;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}